import * as React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
} from "@material-ui/core";

import { User } from "../../userTypes";
import handleMutationError from "app/utils/handleMutationError";

type Props = {
  status: string;
  user: User;
  onClose: Function;
  updateManualVerificationRequest: any;
};

type State = {
  fetchingData: boolean;
  hasComment: boolean;
  commentInput: string;
};

class ManualVerificationStatusChangeConfirmationModal extends React.Component<
  Props,
  State
> {
  state = { fetchingData: false, hasComment: false, commentInput: "" };

  updateManualVerificationRequest = async (status: string) => {
    try {
      this.setState({ fetchingData: true });
      await this.props.updateManualVerificationRequest({
        variables: {
          status: status,
          externalReference: this.props.user.external_reference,
          comment: this.state.commentInput,
        },
      });
      this.setState({ fetchingData: false });
      window.location.reload();
    } catch (error) {
      handleMutationError(error);
    }
  };

  buttonHasRequiredInputs = (): boolean => {
    return this.state.commentInput.length > 0;
  };

  handleCommentChange = (value: string) => {
    this.setState({
      commentInput: value,
    });
  };

  render() {
    return (
      <Dialog open={true} onClose={() => this.props.onClose()}>
        <DialogTitle>
          <DialogContentText>
            {this.props.status === "verified"
              ? "Confirm successful verification of user:"
              : "Confirm verification rejection of user:"}
          </DialogContentText>
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: "pre-wrap" }}>
            Email: <strong>{this.props.user.email}</strong>
          </Typography>
          <Typography style={{ whiteSpace: "pre-wrap" }}>
            ID: <strong>{this.props.user.identity_number}</strong>
          </Typography>
          {this.props.status === "rejected" ? (
            <Typography style={{ marginTop: "20px" }}>
              Please provide a reason for the rejection below:
            </Typography>
          ) : (
            <Typography style={{ marginTop: "20px" }}>
              Please provide a comment for the verification below:
            </Typography>
          )}
          <div>
            <TextField
              label="Comment"
              style={{ width: "100%" }}
              value={this.state.commentInput}
              onChange={(event) => this.handleCommentChange(event.target.value)}
              multiline
              margin="normal"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.onClose()}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              this.updateManualVerificationRequest(this.props.status);
            }}
            disabled={
              !this.buttonHasRequiredInputs() || this.state.fetchingData
            }
          >
            {this.state.fetchingData ? "Updating" : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const updateManualVerificationRequest = graphql(
  gql`
    mutation updateManualVerificationRequest(
      $externalReference: String!
      $status: String!
      $comment: String
    ) {
      update_latest_verification_request(
        external_reference: $externalReference
        status: $status
        comment: $comment
      )
    }
  `,
  {
    name: "updateManualVerificationRequest",
  }
);

export default withRouter(
  compose<any>(updateManualVerificationRequest)(
    ManualVerificationStatusChangeConfirmationModal
  )
);
